import { Validator } from '@vista-digital/validator';
export const defaultMemberFormDateOfBirthFieldConfig = {
    mask: undefined
};
export const memberFormDateOfBirthFieldConfigValidator = Validator.object({
    mask: Validator.optional(Validator.nonEmptyString)
});
//# sourceMappingURL=date-of-birth-field.js.map